import React, { Fragment, useContext, useRef, useState } from "react"
import { Alert } from "react-bootstrap"

import useLog from "../../hooks/useLog"
import useTxSender from "../../hooks/useTxSender"

import { Row } from "../../components/Row"
import { Spaces } from "../../components/Spaces"
import { TextDisplay } from "../../components/TextDisplay/TextDisplay"
import { forceFloat } from "../../helpers/helpers"
import { UserContext } from "../../Contexts/UserContext/UserContext"
import RowWithTitle from "../../components/RowWithTitle"
import { confirmPopup, confirmPopupHard } from "../../components/confirmPopup"
import SoldeToken from "../../components/SoldeToken"
import SuccessTxSender from "../../components/SuccessTxSender"
import { default_func_jsx_fail } from "../../helpers/helpers"
import Bold from "../../components/Bold.js"



export default function Slide_BurnOwnTokens(props) {
	const userContext = useContext(UserContext)
	const log = useLog("Slide_BurnOwnTokens: ")


	// --- VARS ---

	const coinprops = userContext.get_selected_coin_props()
	const tokenID = coinprops.tokenid
	const tokenName = coinprops.name

	const tokenActionID = tokenID + "_burn" // or mint_delphe ?
	const mess_default = "" //"Un récapitulatif des "+tokenName+" à burn va s'afficher ici"

	// state & refs
	const [nbtoburn, set_nbtoburn] = useState("")
	const ref_messageEndRef = useRef(null) // for autoscroll

	const array_bool_user_inputs = [
		Boolean(nbtoburn && nbtoburn > 0),
	]

	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (token_balance != null) // && (context.bsvprice !=null)


	// --- FUNCTIONS ---

	async function func_empty_fields() {
		set_nbtoburn("")
	}

	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	const jsx_sending = <Fragment>
		Burn en cours de {nbtoburn} {tokenName}...&nbsp;
		<i className="reloadIcon fas fa-sync fa-spin" />
	</Fragment>


	const func_jsx_success = (txstate) => {
		return (
			<SuccessTxSender txstate={txstate}>
				Burn de {txstate.nbtokens} {tokenName} avec succès !
			</SuccessTxSender>
		)
	}

	// --- HOOK useTxSender ---

	const [
		bool_broadcast_lock,
		func_resetMess,
		dict_sendbutton_style,
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
		)


	// --- FUNCTIONS ---

	const handleChangeVal = (event) => {
		if (bool_broadcast_lock) return  // don't allow edit during sending
		func_resetMess()

		var val = event.target.value
		val = val.toString().replace(/[^0-9.,]/g, "");
		val = forceFloat(val, 2)

		set_nbtoburn(val)
	}


	const handleClickBurn = async (event) => {
		event.preventDefault()  // prevent redirection
		if (bool_broadcast_lock) return

		const confirm_message = "Burner " + nbtoburn + " " + tokenName + " ?"
		var confirmed = await confirmPopup(confirm_message)
		if (!confirmed) return  // abort

		// async but we don't want to await here !
		userContext.burn_tokens(nbtoburn)
	}


	const handleClickBurnAll = async (event) => {
		event.preventDefault()  // prevent redirection
		if (bool_broadcast_lock) return

		const confirm_message = "Tout burner, êtes vous sûr ?"
		const action_name = "burner tous mes " + tokenName
		var confirmed = await confirmPopupHard(confirm_message, action_name)
		if (!confirmed) return  // abort

		// async but we don't want to await here !
		userContext.burn_tokens_all()
	}


	// --- DISPLAY ---

	log("\n nbtoburn = ", nbtoburn,
		"\n bool_broadcast_lock=", bool_broadcast_lock,)

	var burnAll_style = {}
	if (!bool_context_has_loaded) {
		burnAll_style = { pointerEvents: "none", backgroundColor: "grey" }
	}

	return (
		<div>
			<h1><i className="fas fa-fire" /><Spaces count="3" />
				Burn de {tokenName}
			</h1>
			<br />

			{userContext.ownerIsAdmin ? null : <>
				<Alert variant="danger">
					<Bold>Vous ne semblez pas être l'administrateur de ce token.</Bold>
				</Alert><br />
			</>}

			<center>
				<SoldeToken />
				<br />
			</center>

			<RowWithTitle title={<Fragment>
				Amount of {tokenName} to burn
			</Fragment>}>
				<input value={nbtoburn}
					onChange={handleChangeVal}
					type='number' id='nbtoburn' min="0" step="1"
					placeholder="12.34" className='item' />
			</RowWithTitle>

			<center>
				<div ref={ref_messageEndRef}>
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Row>
				<button style={dict_sendbutton_style} onClick={handleClickBurn} className="submitbutton">
					Burner {nbtoburn ? " " + nbtoburn + " " + tokenName : ""}
				</button>
			</Row>
			<br /><br /><br />

			<h1><i className="fas fa-fire" /><Spaces count="3" />
				Burner tout
			</h1>
			<br /><br />

			<Row>
				<button style={burnAll_style} onClick={handleClickBurnAll} className="submitbutton">
					Burner tous mes {tokenName} {token_balance ? "(" + token_balance + ")" : ""}
				</button>
			</Row>
			<br /><br /><br />

		</div>
	)
}
